import { Box, Grid } from "@mui/material";
import { Link } from "react-router-dom";

import mockData from '../../mocks/Tours';
import appBarMock from '../../mocks/app-bar';

import './footer.scss';
import WhatsApp from "../whats-app/whats-app";

const Footer = () => {

    return (
        <>
            <WhatsApp />
            <footer>
                <Box sx={{ 
                    flexGrow: 1, 
                    minHeight: '300px',
                    backgroundColor: '#333',
                    color: '#FFF',
                    }}  
                    style={{ padding: '30px', display: 'flex', justifyContent: 'center' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4} className="container-our-services">
                                <h3>Contact us</h3>
                                <div><strong>In Los Cabos</strong></div>
                                <div><strong>Phone:</strong>{ appBarMock.phone }</div>
                                <div><strong>Email:</strong>{ appBarMock.email }</div>
                            </Grid>
                            <Grid item xs={12} md={4} className="container-our-services">
                                <h3>Our services</h3>
                                {
                                    mockData.map((item, i) => {
                                        return(
                                            <Link to={`/tours/${item.id}`} key={i} className='links'>- { item.title }</Link>
                                        )
                                    })
                                }
                            </Grid>
                            <Grid item xs={12} md={4} className="container-our-services">
                                <h3>Related Pages</h3>
                                {
                                    appBarMock.footer.relatedPages!.map((item, i) => {
                                        return(
                                            <a href={item.url} key={i} target="_new" className='links'><span>{ item.urlText }</span></a>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>
                </Box>
            </footer>
        </>
    );
}

export default Footer;